/**
 * Un état de la commande
 */
export class BoutiqueEtatCommande {
    /**
     * Constructeut de l'objet
     * @param row Paramètres du constructeur
     */
    constructor(row) {
        if (row) {
            const { idEtatCommande, libelle } = row;
            this.idEtatCommande = idEtatCommande;
            this.libelle = libelle;
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQm91dGlxdWVFdGF0Q29tbWFuZGUuY2xhc3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJCb3V0aXF1ZUV0YXRDb21tYW5kZS5jbGFzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUNILE1BQU0sT0FBTyxvQkFBb0I7SUFXaEM7OztPQUdHO0lBQ0gsWUFBbUIsR0FBa0M7UUFDcEQsSUFBSSxHQUFHLEVBQUU7WUFDUixNQUFNLEVBQUUsY0FBYyxFQUFFLE9BQU8sRUFBRSxHQUFHLEdBQUcsQ0FBQztZQUN4QyxJQUFJLENBQUMsY0FBYyxHQUFHLGNBQWMsQ0FBQztZQUNyQyxJQUFJLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQztTQUN2QjtJQUNGLENBQUM7Q0FDRCJ9